import { createRouter, createWebHashHistory } from "vue-router"
const router = createRouter({
  history: createWebHashHistory(),
  routes:[
    {
      path: "/",
      redirect: "/privacy",
    },
    {
      path: "/terms",
      name: "Terms",
      component: () =>
        import(
         "@/pages/terms.vue"
        ),
      
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () =>
        import(
         "@/pages/privacy.vue"
        ),
      
    },
       {
      path: "/consult",
      name: "consult",
      component: () =>
        import(
         "@/pages/appStore/consult.vue"
        ),
      
    },
    {
      path: "/activity",
      name: "activity",
      component: () =>
        import(
         "@/pages/appStore/activity.vue"
        ),
      
    },
   
  ]
});
export default router;


